import React, { useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { Button, CircularProgress, Alert, Box } from '@mui/material';

const PaymentForm = () => {
    const stripe = useStripe();
    const elements = useElements();
    const [isProcessing, setIsProcessing] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!stripe || !elements) return;

        setIsProcessing(true);
        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: `${window.location.origin}/pay/payment-success`,
            },
        });

        if (error.type === "card_error" || error.type === "validation_error") {
            setError(error.message);
        } else {
            setError("An unexpected error occurred.");
        }
        setIsProcessing(false);
    };

    return (
        <Box component="form" onSubmit={handleSubmit}>
            <PaymentElement />
            <Button type="submit" disabled={isProcessing || !stripe} fullWidth variant="contained" sx={{ mt: 3 }}>
                {isProcessing ? <CircularProgress size={24} /> : "Pay Now"}
            </Button>
            {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
        </Box>
    );
};

export default PaymentForm;